import { gql, useQuery } from "@apollo/client"
import { ChatExamplesPayload } from "./types"

export const CHAT_EXAMPLES_QUERY = gql`
  query GetChatExamples {
    chatExamples {
      examples {
        question
        answer
      }
      capabilities
      limitations
    }
  }
`

interface ChatExamplesQueryResult {
  chatExamples: ChatExamplesPayload
}

export const useChatExamples = () => {
  const { data, loading, error, refetch } = useQuery<ChatExamplesQueryResult>(CHAT_EXAMPLES_QUERY, {
    fetchPolicy: "cache-first",
    nextFetchPolicy: "cache-first",
  })

  const payload = data?.chatExamples

  return {
    examples: payload?.examples ?? [],
    capabilities: payload?.capabilities ?? [],
    limitations: payload?.limitations ?? [],
    hasData:
      !!payload &&
      ((payload.examples && payload.examples.length > 0) ||
        (payload.capabilities && payload.capabilities.length > 0) ||
        (payload.limitations && payload.limitations.length > 0)),
    loading,
    error,
    refetch,
  }
}

